import { ENV } from '@shared/constants/env'
import type { TossPaymentsSDK } from '@tosspayments/tosspayments-sdk'
import { loadTossPayments } from '@tosspayments/tosspayments-sdk'

const CLIENT_KEY = ENV.TOSS_CLIENT_KEY
const MAX_RETRIES = 3

let tossPaymentsInstance: TossPaymentsSDK | null = null

/** TossPayments SDK 싱글턴 초기화 (최대 3회 재시도) */
export async function getTossPayments(): Promise<TossPaymentsSDK> {
  if (!CLIENT_KEY) {
    throw new Error('토스 페이먼츠 관련 환경변수가 설정되지 않았어요')
  }

  if (tossPaymentsInstance) {
    return tossPaymentsInstance
  }

  let lastError: unknown
  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      tossPaymentsInstance = await loadTossPayments(CLIENT_KEY)
      return tossPaymentsInstance
    } catch (error) {
      lastError = error
    }
  }

  throw lastError
}
